module.exports = __webpack_public_path__ + "static/kazalo-fcd6bb7369045cf1d4571f553e18493a.pdf";